// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9442c416","667":"b6db34e1","867":"a5bbc9e1"}[chunkId] + ".chunk.js";
};